import {css} from "@panda/css";

// Shared accordion animation overrides for the FAQ section — the @pg-design/accordion-module defaults
// (chevron 0.6s, expand 0.3s) feel sluggish here, so we speed them up locally without touching the package.

// Faster chevron rotation — the toggle is the accordion header's direct-child span
export const faqAccordionHeaderAnimationStyle = css({
    "& > span": {
        transition: "transform 0.12s ease-in-out"
    }
});

// Faster expand/collapse — override on the Content wrapper (grid-template-rows animation)
export const faqAccordionContentWrapStyle = css({
    transition: "grid-template-rows 0.18s ease-out"
});
import {css} from "@panda/css";

// Shared accordion animation overrides for the FAQ section — the @pg-design/accordion-module defaults
// (chevron 0.6s, expand 0.3s) feel sluggish here, so we speed them up locally without touching the package.

// Faster chevron rotation — the toggle is the accordion header's direct-child span
export const faqAccordionHeaderAnimationStyle = css({
    "& > span": {
        transition: "transform 0.12s ease-in-out"
    }
});

// Faster expand/collapse — override on the Content wrapper (grid-template-rows animation)
export const faqAccordionContentWrapStyle = css({
    transition: "grid-template-rows 0.18s ease-out"
});
